import { useEffect } from 'react';

interface DocumentMeta {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(name: string, content?: string) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function useDocumentMeta({ title, description, keywords }: DocumentMeta) {
  useEffect(() => {
    document.title = title;
    upsertMeta('description', description);
    upsertMeta('keywords', keywords);
  }, [title, description, keywords]);
}